import { render, staticRenderFns } from "./AddMedical.vue?vue&type=template&id=3d65c87a&scoped=true&"
import script from "./AddMedical.vue?vue&type=script&lang=js&"
export * from "./AddMedical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d65c87a",
  null
  
)

export default component.exports